export const PROJECTS_TRIAL_DAYS = 7;

export type ProjectsAccessKind = 'full' | 'trial' | 'expired' | 'none' | 'hidden';

export type ProjectsCompany = {
  isOwner?: boolean;
  modules?: {
    projects?: boolean;
    projectsHidden?: boolean;
    projectsTrialStartedAt?: string;
    projectsTrialEndsAt?: string;
  };
} | null | undefined;

export type ProjectsAccess = {
  enabled: boolean;
  kind: ProjectsAccessKind;
  endsAt?: string;
};

const asTime = (value?: string | Date | null): number | null => {
  if (!value) return null;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? null : time;
};

export const getProjectsAccess = (company: ProjectsCompany): ProjectsAccess => {
  if (!company) {
    return { enabled: false, kind: 'none' };
  }
  if (company.isOwner || company.modules?.projects) {
    return { enabled: true, kind: 'full' };
  }
  const endsAt = company.modules?.projectsTrialEndsAt;
  const endsAtTime = asTime(endsAt);
  if (endsAtTime && endsAtTime > Date.now()) {
    return { enabled: true, kind: 'trial', endsAt };
  }
  if (company.modules?.projectsHidden) {
    return { enabled: false, kind: 'hidden', endsAt };
  }
  if (company.modules?.projectsTrialStartedAt) {
    return { enabled: false, kind: 'expired', endsAt };
  }
  return { enabled: false, kind: 'none' };
};

export const formatProjectsTrialLabel = (endsAt?: string | Date | null) => {
  const time = asTime(endsAt);
  if (!time) {
    return { daysLeft: 0, label: 'Demo ended', dateLabel: '' };
  }
  const dateLabel = new Date(time).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
  const remaining = time - Date.now();
  if (remaining <= 0) {
    return { daysLeft: 0, label: 'Demo ended', dateLabel };
  }
  if (remaining < 24 * 60 * 60 * 1000) {
    return { daysLeft: 1, label: 'Ends today', dateLabel };
  }
  const daysLeft = Math.ceil(remaining / (24 * 60 * 60 * 1000));
  return {
    daysLeft,
    label: `${daysLeft} ${daysLeft === 1 ? 'day' : 'days'} left`,
    dateLabel
  };
};
